import { EliotModule } from '~/store/modules/eliot';
import { SearchModule } from '~/store/modules/search';
import { UserModule } from '~/store/modules/user';
import { userIdDbRe } from '~common-helpers';

export async function beforeUpdateAndEnter(to: any, from: any, next: any): Promise<void> {
    const { userIdentifier, plantId, eliotGatewayId } = to.params;
    let newSearch = null;
    if (userIdentifier) {
        const isUserId = userIdDbRe.test(userIdentifier);
        // check if we have a user (!userModule.id) or if current user is not the same as the userIdentifier
        // or if it is the same userIdentifier, check a search is needed if the previous user was not an eliot user
        if (!UserModule.id
            || userIdentifier.toLowerCase() !== (isUserId ? UserModule.id : UserModule.userMail.toLowerCase())
            || !UserModule.isEliot
        ) {
            newSearch = {
                searchText: userIdentifier,
                paramType: isUserId ? 'user_id' : 'user_mail',
                fullParams: { userIdentifier, plantId, eliotGatewayId },
                prefix: 'legrand://'
            };
        }
    } else if (eliotGatewayId && !EliotModule.deviceExists(eliotGatewayId)) {
        newSearch = {
            searchText: eliotGatewayId,
            paramType: 'device_id',
            prefix: 'legrand://'
        };
    }
    if (newSearch) {
        await SearchModule.search(newSearch);
        next(false);
    } else {
        if (EliotModule.currentGatewayId !== eliotGatewayId) {
            EliotModule.setCurrentGatewayId(eliotGatewayId);
            EliotModule.setFirstModuleId();
        }
        if (EliotModule.currentPlantId !== plantId || !EliotModule.currentPlant) {
            EliotModule.setCurrentPlantId(plantId);
            if ((!eliotGatewayId && !userIdentifier) || (plantId && !EliotModule.currentPlant)) {
                await EliotModule.getPlantInfo(plantId);
            }
        }
        if (userIdentifier) {
            to.params.userIdentifier = encodeURIComponent(userIdentifier);
        }
        next();
    }

}

export default {
    beforeUpdateAndEnter,
};
